var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "+_vm._s(_vm.loadingtxt)+"\n    ")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.txt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }